import { Navigate } from "react-router-dom";
// import OrganizationDetails from "../components/organizationDetails";
// import AddressCreate from "../components/organizationDetails/address/addressCreate";
import PersonalDetails from "../components";
import SvgIcons from "../../../../shared/components/svgIcons";

const personalDetailsRoute = {
  icon: SvgIcons.SettingsIcon,
  name: "Settings",
  link: "/settings",
  path: "settings",
  element: "",
  index: 1000,
  children: [
    {
      path: "personal-details",
      element: <PersonalDetails />,
      name: "User Profile",
      permission: "User Profile",
      index: 2,
      link: "/settings/personal-details",
      icon: SvgIcons.PersonalDetailsIcon,
    },
    {
      path: "",
      element: <Navigate to="/settings/personal-details" replace />,
    },
  ],
};
export default personalDetailsRoute;
